import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-drop-down-list-element',
  templateUrl: './drop-down-list-element.component.html',
  styleUrls: ['./drop-down-list-element.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class DropDownListElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;
  @Input() formValues: any | undefined;

  constructor() { }

  ngOnInit(): void {
  }

  public getControlName(): string {
    return 'input' + this.getName();
  }

  public getName(): string {
    return this.element?.name ?? '';
  }

  public getLabel(): string {
    return this.element?.label ?? '';
  }

  public isLabelVisible(): boolean {
    return this.getLabel() !== '' && this.isControlVisible();
  }

  public isControlVisible(): boolean {
    return !_.isNil(this.element) && !_.isNil(this.formValues);
  }

  public isRequired(): boolean {
    return this.element?.required ?? false;
  }

  public getItems(): Array<object> {
    return this.element?.values ?? [];
  }

  public getTextField(): string {
    return this.element?.nameField ?? '';
  }

  public getValueField(): string {
    return this.element?.valueField ?? '';
  }
}
